'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { PortfolioViewerMode } from '@/components/portfolio/portfolio-context';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { LinkForwardIconSolid } from '@/components/ui/icon/glyphs';
import { useFormattedCurrency } from '@/lib/currency';
import { withDemoMode } from '@/lib/network';
import { useUserNetwork } from '@/lib/network/client';
import { ShareModal } from '@/lib/share';
interface BackerRewardsShareButtonProps {
  userId: string;
  viewerMode: PortfolioViewerMode;
  handle: string | null;
  displayName: string | null;
  totalEarnedD6: string;
  marketsBacked: number;
}
export function BackerRewardsShareButton(t0) {
  const $ = _c(27);
  const {
    userId,
    viewerMode,
    handle,
    displayName,
    totalEarnedD6,
    marketsBacked
  } = t0;
  const t = useTranslations("portfolio.backerRewards.share");
  const {
    formatD6
  } = useFormattedCurrency();
  const {
    network
  } = useUserNetwork();
  let t1;
  if ($[0] !== displayName || $[1] !== formatD6 || $[2] !== handle || $[3] !== marketsBacked || $[4] !== t || $[5] !== totalEarnedD6 || $[6] !== viewerMode) {
    const name = handle ? `@${handle}` : displayName || t("anonymous");
    const values = {
      name,
      amount: formatD6(totalEarnedD6, "full"),
      count: marketsBacked
    };
    t1 = viewerMode === "own" ? t("ownText", values) : t("otherText", values);
    $[0] = displayName;
    $[1] = formatD6;
    $[2] = handle;
    $[3] = marketsBacked;
    $[4] = t;
    $[5] = totalEarnedD6;
    $[6] = viewerMode;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const text = t1;
  let t2;
  bb0: {
    if (typeof window === "undefined") {
      t2 = "";
      break bb0;
    }
    let t3;
    if ($[8] !== network || $[9] !== userId) {
      const target = new URL(`/portfolio/${encodeURIComponent(userId)}`, window.location.origin);
      withDemoMode(target, network === "mainnet" ? "mainnet" : "devnet");
      target.searchParams.set("rewards", "backer");
      t3 = target.toString();
      $[8] = network;
      $[9] = userId;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = t3;
  }
  const url = t2;
  let t3;
  if ($[11] !== userId || $[12] !== viewerMode) {
    t3 = {
      kind: "backer_rewards",
      userId,
      viewerMode
    };
    $[11] = userId;
    $[12] = viewerMode;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t) {
    t4 = t("title");
    $[14] = t;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t) {
    t5 = t("label");
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon icon={LinkForwardIconSolid} className="size-4" aria-hidden="true" />;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5) {
    t7 = <AnimatedButton variant="secondary" size="default" aria-label={t5}>{t6}</AnimatedButton>;
    $[19] = t5;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t7 || $[24] !== text || $[25] !== url) {
    t8 = <ShareModal surface={t3} url={url} text={text} title={t4} trigger={t7} />;
    $[21] = t3;
    $[22] = t4;
    $[23] = t7;
    $[24] = text;
    $[25] = url;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}